import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServicesVisit";
import { toast } from "react-toastify";

export const getDelegatesList = createAsyncThunk(
  "delegate/fetchAll",
  async (paramsData = {}, thunkAPI) => {
    const { page = 1, itemsPerPage, limit, filter = {} } = paramsData;
    try {
      const finalLimit = limit || itemsPerPage || 10;

      const params = new URLSearchParams({
        page: page,
        limit: finalLimit,
      });

      if (filter.search) {
        params.append('search', filter.search);
      }
      
      if (filter.status === 0 || filter.status === 1) {
        params.append("status", filter.status);
      }

      const URL = `${API_URL}${API.DELEGATES.GETDELEGATES}?${params.toString()}`;
      const response = await axiosService.get(URL);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Erreur inconnue lors du chargement des délégués.";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const addDelegate = createAsyncThunk("delegate/add", async (data, thunkAPI) => {
  try {
    const response = await axiosService.post(`${API_URL}${API.DELEGATES.ADDDELEGATE}`, data);
    toast.success("Le délégué a été ajouté avec succès.");
    return response.data;
  } catch (err) {
    const errorMessage = err.response?.data?.message || "Erreur lors de l'ajout du délégué.";
    toast.error(errorMessage);
    return thunkAPI.rejectWithValue(errorMessage);
  }
});

export const deleteDelegate = createAsyncThunk(
  "delegate/delete",
  async (id, thunkAPI) => {
    try {
      await axiosService.delete(`${API_URL}${API.DELEGATES.GETDELEGATES}/${id}`);
      toast.success("Le délégué a été supprimé avec succès.");
      return id;
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Erreur lors de la suppression du délégué.";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const updateDelegate = createAsyncThunk(
  "delegate/update",
  async (data, thunkAPI) => {
    try {
      const response = await axiosService.patch(`${API_URL}${API.DELEGATES.UPDATEDELEGATE}/${data.userId}`, data.userData);
      toast.success("Le délégué a été modifié avec succès.");
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Erreur lors de la modification du délégué.";
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const assignPersons = createAsyncThunk(
  "persons/assignPersons",
  async (data, thunkAPI) => {
    try {
      const response = await axiosService.post(
        `${API_URL}${API.DELEGATES.GETDELEGATES}/${data?.id}/assign-persons`,
        { person: data?.persons }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDelegateById = createAsyncThunk(
  "delegate/getById",
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.get(`${API_URL}${API.DELEGATES.GETDELEGATES}/${id}`);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || `Erreur lors de la récupération du délégué #${id}.`;
      toast.error(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getDelegatesSummary = createAsyncThunk(
  "delegate/fetchSummary",
  async (filters = {}, thunkAPI) => {
    try {
      const params = new URLSearchParams();
      if (filters.delegateIds?.length > 0) params.append('delegateIds', filters.delegateIds.join(','));
      if (filters.regionIds?.length > 0) params.append('regionIds', filters.regionIds.join(','));
      
      // UTILISER LES CLÉS DÉJÀ FORMATÉES PAR LA PAGE
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate) params.append('endDate', filters.endDate);

      const response = await axiosService.get(`${API_URL}${API.DELEGATES.GETDELEGATES}/summary/reports-by-delegate?${params.toString()}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Erreur");
    }
  }
);